module.exports = __webpack_public_path__ + "img/7.a89c6877.png";